import { Injectable } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { EmployeeMoodApi } from '../../../shared/nestjs/gd-only/services/employee-mood.api';
import { NestResponsesProvider } from '../../../shared/nestjs/nest-responses';
import {
  RequestListEmployeeMood,
  ResponseCategorieEmployeeMoodDto,
  ResponseDevelopmentMood,
  ResponseListEmployeeMood,
  ResponseTrendingTopic
} from '../../../shared/nestjs/gd-only/dto/employee-mood.dto';
import { AnalyticsProvider } from '../../../providers/analytics/analytics';
import { EventNameAnalytics } from '../../../helpers/event-name-analytics';

@Injectable()
export class CompanyMoodBloc {

  constructor(
    public modalCtrl: ModalController,
    public employeeMoodApi: EmployeeMoodApi,
    public nestResponse: NestResponsesProvider,
    public analyticsProvider: AnalyticsProvider
  ) {
  }

  async checkEmployeeSurvey() {
    try {
      const result = await this.getCategories();
      if (result) {
        this.showSurveyPage(result);
      }
    } catch (error) {
      return null;
    }
  }

  getCategories() {
    return new Promise<Array<ResponseCategorieEmployeeMoodDto>>((resolve, reject) => {
      this.employeeMoodApi.getCategory()
        .map(res => res.data)
        .subscribe(result => {
          resolve(result)
        }, error => {
          reject(error)
        })
    })
  }

  submitSurvey(payload: { mood: number, categoryList: number[], notes?: string }) {
    return new Promise((resolve, reject) => {
      this.employeeMoodApi.submitSurvey(payload)
        .map(res => res.data)
        .subscribe(result => {
          this.analyticsProvider.trackEvent(EventNameAnalytics.COMPANY_MOOD, payload.mood);
          resolve(result)
        }, error => {
          reject(error)
        })
    })
  }

  getScore(): Promise<number> {
    return new Promise<number>((resolve, reject) => {
      this.employeeMoodApi.score()
        .map(res => res.data)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

  getHappyList(payload: RequestListEmployeeMood): Promise<ResponseListEmployeeMood[]> {
    return new Promise<ResponseListEmployeeMood[]>((resolve, reject) => {
      this.employeeMoodApi.happyList(payload)
        .map(res => res.data)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

  getUnHappyList(payload: RequestListEmployeeMood): Promise<ResponseListEmployeeMood[]> {
    return new Promise<ResponseListEmployeeMood[]>((resolve, reject) => {
      this.employeeMoodApi.unhappyList(payload)
        .map(res => res.data)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

  getTrending(): Promise<ResponseTrendingTopic[]> {
    return new Promise<ResponseTrendingTopic[]>((resolve, reject) => {
      this.employeeMoodApi.trending()
        .map(res => res.data)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

  getDevelopmentMood(): Promise<ResponseDevelopmentMood[]> {
    return new Promise<ResponseDevelopmentMood[]>((resolve, reject) => {
      this.employeeMoodApi.developmentMood()
        .map(res => res.data)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

  /**
   * OPEN SURVEY EMPLOYEE COMPANY MOOD
   */
  async showSurveyPage(params) {
    const modal = this.modalCtrl.create('SurveyEmployeeModalPage', { reason: params });
    modal.onDidDismiss((data) => {
      return data;
    });

    await modal.present()
  }

  getCategoryList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.employeeMoodApi.getMoodCategory()
        .map(res => res)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

  saveCategoryList(name: string, description: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.employeeMoodApi.saveMoodCategory({ name, description })
        .map(res => res)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

  deleteCategoryList(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.employeeMoodApi.deleteMoodCategory(id)
        .map(res => res)
        .subscribe(result => resolve(result), error => reject(error))
    })
  }

}



// WEBPACK FOOTER //
// ./src/bloc/feature/company-mood/company-mood.bloc.ts